import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { useGoogleOneTapLogin } from '@react-oauth/google';

const GoogleOneTapLogin = ({ socialSignIn, disabled }) => {
  const handleAfterSuccess = async (data) => {
    try {
      const res = await fetch(`https://oauth2.googleapis.com/tokeninfo?id_token=${data.credential}`);
      if (res?.status === 200 && res?.json) {
        const userObj = await res.json();
        socialSignIn('google', { accessToken: data.credential, userID: userObj.sub }, true);
      }
    } catch (error) {
      throw new Error('Something went wrong!');
    }
  };

  useGoogleOneTapLogin({
    onSuccess: handleAfterSuccess,
    onError: () => {},
    use_fedcm_for_prompt: true,
    prompt_parent_id: 'google_one_tap_login',
    itp_support: true,
    auto_select: false,
    cancel_on_tap_outside: false,
    disabled,
  });

  return <div />;
};

GoogleOneTapLogin.defaultProps = {
  disabled: false,
};

GoogleOneTapLogin.propTypes = {
  socialSignIn: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default GoogleOneTapLogin;
